import React, { useState } from "react";
import { Modal, Typography, Input, Button, Space, Card, message } from "antd";
import { MailOutlined, ArrowLeftOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { ReSendOTPToMail, TransferTokensToUser, UpdateRequest } from "../../redux/auth/RequestsAuthSlice";

const { Title, Text } = Typography;

// Q-04 (HIGH, backend-coordinated): `recipientWalletAddress`, `amount`,
// `type`, and `otpId` are currently read from sessionStorage and then
// echoed back to the backend below. This is safe ONLY if the backend
// ignores these fields and derives the real transfer parameters from
// `otpId` / `requestId` on its own side. If the backend currently trusts
// the posted values, an XSS that lands between "user requests transfer" and
// "user enters OTP" can rewrite the amount / address to attacker-controlled
// values — the OTP then authorises the attacker's transfer.
// See AUDIT_REPORT_CL.md Q-04 for the backend action required.
const TransferTokenOTP = () => {
  const { isLoading } = useSelector((state) => state?.counter);
  const [otp, setOtp] = useState("");

  const navigatePage = sessionStorage.getItem("currentPage");
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const recipientEmail = sessionStorage?.getItem("transferemail");
  const amount = sessionStorage?.getItem("transferAmount");
  const tokenType = sessionStorage?.getItem("transferType");
  const walletAddress = sessionStorage?.getItem("receiverWalletaddress");

  const onSubmit = () => {
    if (!otp) {
      message.error("OTP is required");
      return;
    }

    if (navigatePage === "/walletdetails") {
      const obj = {
      
        recipientWalletAddress:walletAddress,
        amount,
        type: tokenType,
        otp,
        otpId: sessionStorage?.getItem("OtpId"),
      };
      dispatch(TransferTokensToUser({ obj, navigate }));
    } else {
      const obj = {
        requestId: sessionStorage?.getItem("requestId"),
        action: "1",
        otp,
        otpId: sessionStorage?.getItem("OtpId"),
      };
      dispatch(UpdateRequest({ obj, page: 1, limit: 10, type: 0, navigate }));
    }
  };

  const resendOtp = () => {
    const obj = {
      email: recipientEmail,
      tokenType,
      amount,
    };
    dispatch(ReSendOTPToMail({ obj }));
    // message.success("OTP resent successfully");
  };

  const goBack = () => {
    if (navigatePage === "/walletdetails") {
      navigate("/walletdetails");
    } else {
      navigate("/getrequests");
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <Modal open={true} footer={null} closable={false} centered width={420}>
        <Card bordered={false} style={{ textAlign: "center" }}>
          <MailOutlined style={{ fontSize: 40, color: "#1890ff" }} />
          <Title level={4} style={{ marginTop: 12 }}>
            Please Enter Your OTP
          </Title>
          <Space direction="vertical" size={4} style={{ marginBottom: 16 }}>
            <Text type="secondary">{recipientEmail ?? null}</Text>
            <Text strong>
              {amount ?? null} {tokenType ?? null}
            </Text>
            <Text type="secondary" style={{ fontSize: 12 }}>
              {walletAddress ?? null}
            </Text>
          </Space>

          <Input
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            onPressEnter={onSubmit}
            style={{ textAlign: "center", marginBottom: 12 }}
            maxLength={6}
          />

          <Space style={{ width: "100%", justifyContent: "space-between" }}>
            <Button onClick={goBack} icon={<ArrowLeftOutlined />}>
              Go Back
            </Button>
            <Button type="primary" onClick={onSubmit}>
              Submit
            </Button>
            <Button onClick={resendOtp}>Resend OTP</Button>
          </Space>
        </Card>
      </Modal>
    </>
  );
};

export default TransferTokenOTP;
